import { fromEvent, merge } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import {
  debounceTime,
  map,
  filter,
  distinctUntilChanged,
  switchMap,
} from 'rxjs/operators'

import getCsrfToken from '@newswebsiteapp/shared/lib/getCsrfToken'

function isValidEmail(email) {
  // console.log("isValidEmail", email)
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export default function setupOtpField({ otpFieldForm, emailInput }) {
  if (!otpFieldForm) {
    // console.log("otpFieldForm emtpy")
    throw new Error('otpFieldForm emtpy')
  }
  if (!emailInput) {
    // console.log("emailInput emtpy")
    throw new Error('emailInput emtpy')
  }

  // https://stackoverflow.com/questions/45495188/rxjs-fromevent-to-handle-multiple-events

  const events = [
    // "propertychange",
    'focus',
    // "change",
    // "keyup",
    // "mouseup",
    'input',
    // "paste",
    'blur',
  ]

  const eventStreams = events.map((e) => fromEvent(emailInput, e))
  const allEvents = merge(...eventStreams)

  // https://github.com/ReactiveX/rxjs/blob/master/doc/tutorial/applications.sm
  return allEvents
    .pipe(
      map((e) => $(e)[0]),
      map((e) => $(e.target).val()),
      filter(isValidEmail),
      distinctUntilChanged(),
      debounceTime(1000),
      switchMap((val) => {
        const x = ajax.getJSON(
          `/api/is-email-registered?email=${encodeURIComponent(val)}`,
          { 'X-CSRF-Token': getCsrfToken() },
        )

        // console.log("ajax", val, x)

        return x
      }),
    )
    .subscribe({
      // Mentioned as {exists, otp_enabled} in controller generated json
      next: ({ exists, otp_enabled }) => {
        // console.log("req from setupOtpField")

        if (exists && otp_enabled) {
          otpFieldForm.removeClass('hidden', otpFieldForm)
        } else {
          otpFieldForm.addClass('hidden', otpFieldForm)
        }
      },
      error: (error) => {
        console.log('error', error)
      },
    })
}
